import { render, staticRenderFns } from "./SlideUp.vue?vue&type=template&id=6e552874&"
import script from "./SlideUp.vue?vue&type=script&lang=js&"
export * from "./SlideUp.vue?vue&type=script&lang=js&"
import style0 from "./SlideUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports